export const diyIcons: any = {
  tp: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>图片</title>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="2.0发帖--状态" transform="translate(-625.000000, -450.000000)">
              <g id="发帖" transform="translate(578.000000, 237.000000)">
                  <g id="icon" transform="translate(31.000000, 201.000000)">
                      <g transform="translate(16.000000, 11.000000)" id="插入图片">
                          <g transform="translate(0.000000, 1.000000)">
                              <rect id="矩形" fill="#828282" opacity="0" x="0" y="0" width="24" height="24" rx="2"></rect>
                              <rect id="矩形" stroke="#828282" stroke-width="1.4" x="2" y="4" width="20" height="16" rx="2"></rect>
                              <circle id="椭圆形" stroke="#828282" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" cx="7.75" cy="9.25" r="1.45"></circle>
                              <polyline id="路径" stroke="#828282" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" points="5 17 8.72331739 13.3663125 11.0566749 15.1880626 13.8567039 12 19.002172 15.8400496"></polyline>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>`,
};
